import storage from '../storage';

export const getSidebarPositionFromStorage = () =>
  storage.getItem('sidebarPosition') &&
  storage.getItem('sidebarPosition') === 'expanded'
    ? storage.getItem('sidebarPosition')
    : 'closed';

export const getIsShrinkSidebarFromStorage = () => {
  const position = getSidebarPositionFromStorage();

  return position === 'closed' ? true : false;
};
